import { getTwoLastSymbolsOfYear } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getTwoLastSymbolsOfYear'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { getQuarterStateTranslationKey } from '../../../helpers/getQuarterStateTranslationKey'
import { FinancialSnapshotOutlookNote } from '../../styledComponents/notes/FinancialSnapshotOutlookNote'
import { NoteWrapper } from '../../styledComponents/notes/noteWrapper/NoteWrapper'
import styles from '../Revenue.module.scss'

interface IGetYearQuarterThView {
  quarter: 1 | 2 | 3 | 4
  currentQuarter: number
  currentYear: number
}

export const getCurrentYearQuarterThView = ({
  quarter,
  currentQuarter,
  currentYear,
}: IGetYearQuarterThView) => {
  return (
    <div>
      <span>
        Q{quarter}’{getTwoLastSymbolsOfYear(currentYear)}
      </span>
      <Translation
        text={getQuarterStateTranslationKey({
          quarter,
          currentQuarter,
          currentYear,
          year: currentYear,
        })}
      />
    </div>
  )
}

export const getPrevYearQuarterThView = ({
  quarter,
  currentQuarter,
  currentYear,
}: IGetYearQuarterThView) => {
  const prevYear = currentYear - 1
  return (
    <div>
      <span>
        Q{quarter}’{getTwoLastSymbolsOfYear(prevYear)}
      </span>
      <Translation
        text={getQuarterStateTranslationKey({
          quarter,
          currentQuarter,
          currentYear,
          year: prevYear,
        })}
      />
    </div>
  )
}

export const getPrevYearThViewTotal = (currentYear: number) => {
  const actualYear = Number(currentYear) - 1
  return (
    <div className={styles.totalTh}>
      <span>FY’{getTwoLastSymbolsOfYear(actualYear)}</span>
      <Translation text={getFormedEltTranslation('financial-table-total-actuals-total')} />
    </div>
  )
}

export const getCurrentYearThViewTotal = (currentYear: number, currentQuarter: number) => {
  const isLastQuarter = currentQuarter === 4
  return (
    <div className={styles.totalTh}>
      <span>FY’{getTwoLastSymbolsOfYear(currentYear)}</span>
      <Translation
        text={getFormedEltTranslation(
          isLastQuarter ? 'financial-table-total-actuals-total' : 'financial-table-total'
        )}
      />
    </div>
  )
}

export const getTwoYearsAgoThTotal = (currentYear: number) => {
  const twYearsAgo = currentYear - 2
  return (
    <div className={styles.totalTh}>
      <span>FY’{getTwoLastSymbolsOfYear(twYearsAgo)}</span>
      <Translation text={getFormedEltTranslation('financial-table-total-actuals-total')} />
    </div>
  )
}

export const getPrevYearThView = (currentYear: number, prefix?: string) => {
  const actualYear = Number(currentYear) - 1
  return (
    <NoteWrapper
      color="dark"
      noteContent={() => <FinancialSnapshotOutlookNote currentQuarter={1} isFullYear />}
      className={styles.headerNotes}
    >
      <div>
        <span>FY’{getTwoLastSymbolsOfYear(actualYear)}</span>
        <Translation
          text={getFormedEltTranslation(
            prefix ? `${prefix}-revenue-table-actual` : 'revenue-table-actual'
          )}
        />
      </div>
    </NoteWrapper>
  )
}

export const getCurrentYearThView = (
  currentYear: number,
  currentQuarter: number,
  prefix?: string
) => {
  const base = 'outlook'
  const translation = prefix ? `${prefix}-revenue-table-${base}` : `revenue-table-${base}`
  return (
    <NoteWrapper
      color={'dark'}
      noteContent={() => <FinancialSnapshotOutlookNote currentQuarter={currentQuarter} />}
      className={styles.headerNotes}
    >
      <div>
        <span>FY’{getTwoLastSymbolsOfYear(currentYear)}</span>
        <Translation text={getFormedEltTranslation(translation)} />
      </div>
    </NoteWrapper>
  )
}

export const getTwoYearsAgoThView = (currentYear: number) => {
  const twYearsAgo = currentYear - 2
  return (
    <div className={styles.totalTh}>
      <span>FY’{getTwoLastSymbolsOfYear(twYearsAgo)}</span>
      <Translation text={getFormedEltTranslation('financial-table-total-actuals')} />
    </div>
  )
}
